const SOURCE_TAG_SEPARATOR = '::';

const SOURCE_DISPLAY_NAMES: Record<string, string> = {
  enelyze: 'Elhub',
  mqtt: 'MQTT',
};

export function getSourceDisplayName(source: string): string {
  return SOURCE_DISPLAY_NAMES[source] ?? source;
}

export function getSourceAndTagFromKey(key: string): { source: string; tag: string } {
  const [source, ...tagParts] = key.split(SOURCE_TAG_SEPARATOR);
  if (tagParts.length === 0) {
    return { source: '', tag: key };
  }

  return {
    source,
    tag: tagParts.join(SOURCE_TAG_SEPARATOR),
  };
}

export function getCombinedSourceTagKey(source: string, tag: string): string {
  return `${source}${SOURCE_TAG_SEPARATOR}${tag}`;
}
